import { assetUrl } from "../../lib/assets";

export function BrandLogo({ compact = false }: { compact?: boolean }) {
	return (
		<span className={`inline-flex shrink-0 items-center ${compact ? "gap-1.5" : "gap-2.5"}`}>
			<img
				src={assetUrl("brand/haha-mascot.png")}
				alt=""
				draggable={false}
				className={`${compact ? "size-6" : "size-9"} shrink-0 object-contain`}
			/>
			<span
				className={`${compact ? "text-[18px]" : "text-[26px]"} font-brand font-bold leading-none text-text`}
			>
				Muhaha
			</span>
		</span>
	);
}
